import { collection, addDoc, deleteDoc, doc, query, where, orderBy, onSnapshot, serverTimestamp, limit } from 'firebase/firestore';
import { db } from '../firebase';

// Notes / conversation d'un dossier. L'autorisation est déduite du document projet (règles).
export class NoteService {
  static subscribe(projectId, callback) {
    try {
      const q = query(collection(db, 'notes'), where('projectId', '==', projectId), orderBy('createdAt', 'asc'), limit(500));
      return onSnapshot(q, (snap) => {
        const items = [];
        snap.forEach((d) => items.push({ id: d.id, ...d.data() }));
        callback(items);
      }, (error) => {
        console.error('Erreur notes:', error);
        callback([]);
      });
    } catch (error) {
      console.error('Erreur config notes:', error);
      return () => {};
    }
  }

  static extractMentions(text) {
    return Array.from(new Set((text.match(/@([\p{L}\p{N}_.-]+)/gu) || []).map((m) => m.slice(1))));
  }

  static async add(projectId, text, author) {
    try {
      const clean = (text || '').trim();
      if (!clean) return { success: false, error: 'Note vide' };
      const ref = await addDoc(collection(db, 'notes'), {
        projectId,
        text: clean,
        mentions: NoteService.extractMentions(clean),
        authorUid: author.uid,
        authorName: author.name || '',
        authorRole: author.role || '',
        createdAt: serverTimestamp()
      });
      return { success: true, id: ref.id };
    } catch (error) {
      console.error('Erreur ajout note:', error);
      return { success: false, error: error.message };
    }
  }

  static async remove(id) {
    try {
      await deleteDoc(doc(db, 'notes', id));
      return { success: true };
    } catch (error) {
      console.error('Erreur suppr note:', error);
      return { success: false, error: error.message };
    }
  }
}
